

/* eslint-disable no-use-before-define */
/* eslint-disable no-unused-vars */
/* eslint-disable react-hooks/exhaustive-deps */

import React, { useCallback, useEffect,useMemo, useRef, useState } from 'react'
import { APIEndpoint, DFPAPIEndpoint } from '../../../utils/axios';
import {editFields,editFields2,editFields3, editFields4, defaultEditFields} from '../../../utils/itemSel'
import { DataGrid, EditModal,UploadModal } from '../../../common';
import DOWNLOAD_ICON from "../../../assets/icons/download-master.svg";
import { onDownloadXlsFile,formatCamelString } from '../../../utils/commonFunctions';
import {TrackingStat,HOST_SERVER,MIMETypes} from '../../../utils/configs';
import usePermissions from '../../../utils/userPermissions';
import { useTranslation } from 'react-i18next';
import editIcon2 from "../../../assets/edit2.svg";
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import searchIcon from '../../../assets/icons/search.svg';
import uploadItemIcon from '../../../assets/icons/upload-items.svg';
import LoadingGIF from '../../../assets/loadingIn.gif';

const Columns = [
  { field: 'itemCode',headerName: 'Item Code',tooltipField:'itemCode',flex:1, cellStyle: {
    whiteSpace: 'nowrap',
    overflow:'hidden',
    textOverflow:'ellipsis',
  },suppressSizeToFit:true, resizable:true, minWidth: 140,width:190 },
  { field: 'itemName',headerName: 'Name', flex:1,suppressSizeToFit:true, resizable:true, minWidth: 200,width:250,
    tooltipField: 'itemName',  cellStyle: {
      whiteSpace: 'nowrap',
      overflow:'hidden',
      textOverflow:'ellipsis',
    },
  },
  { field: 'ssrCode', headerName: 'SSR Code',flex:1, suppressSizeToFit:true, resizable:true, minWidth: 135 },
  { field: 'itemType',headerName: 'Type', flex:1,suppressSizeToFit:true, resizable:true, minWidth: 135 },
  { field: 'itemClassifier',headerName: 'Classifier',valueGetter: (params) => {
    if (params.data&&params.data.itemClassifier) {
       return formatCamelString(params.data.itemClassifier);
    }
    return null;
  }, flex:1,suppressSizeToFit:true, resizable:true, minWidth: 135 },
  { field: 'category',headerName: 'Category',cellStyle: {
    whiteSpace: 'nowrap',
    overflow:'hidden',
    textOverflow:'ellipsis',
  },flex:1, suppressSizeToFit:true, resizable:true, minWidth: 155 },
  { field: 'subCategory',headerName: 'Sub Category',cellStyle: {
    whiteSpace: 'nowrap',
    overflow:'hidden',
    textOverflow:'ellipsis',
  },flex:1, minWidth: 175,suppressSizeToFit:true, resizable:true, },
  { field: 'hsn', headerName: 'HSN',flex:1,  suppressSizeToFit:true, resizable:true,minWidth: 125 },
];

const EditFormFields = [
  {label: 'Item Type', attribute: 'itemType', type: 'select', disabled: false, options: [], required: true },
  {label: 'Item Code', attribute: 'itemCode', type: 'text', disabled: false, required: true },
  {label: 'Item Name', attribute: 'itemName', type: 'text', disabled: false, required: true},
  {label: 'SSR Code', attribute: 'ssrCode', type: 'text', disabled: false},
  {label: 'Category', attribute: 'category', type: 'select', disabled: false, options: [], required: true },
  {label: 'Sub category', attribute: 'subCategory', type: 'select', disabled: true, options: [], required: true },
  {label: 'Item Classifier', attribute: 'itemClassifier', type: 'select', disabled: false, options: [], required: true },
  {label: 'HSN Code', attribute: 'hsn', type: 'text', disabled: false},
  {label: 'Bar Code', attribute: 'barcode', type: 'text', disabled: false},
  {label: 'Section', attribute: 'section', type: 'select', disabled: false, options: [] },
  {label: 'Unit', attribute: 'unit', type: 'select', disabled: false, options: [], required: true },
  {label: 'Weight (in grams)', attribute: 'weight', type: 'number', disabled: false, required: false },
  {label: 'Base Unit', attribute: 'baseUnit', type: 'text', disabled: false},
  {label: 'Color code', attribute: 'colorCode', type: 'text', disabled: false},
  {label: 'Replenishable', attribute: 'replenishable', type: 'number', disabled: false,note:"(Place an order even after stock is exhausted)" },
  {label: 'Description', attribute: 'description', type: 'textarea', disabled: false},
  {label: 'ItemId', attribute: 'itemId', type: 'hidden', disabled: true, required: true },
];

export const ItemMasterPage = (props) => {
  const { t ,ready} = useTranslation();
  const [state, setState] = useState({imageRemoved:false});
  const tableRef = useRef();
  const [perPageLimit, ] = useState(50);
  const [searchKey, setSearchKey] = useState('');
  const [itemTypeList, setItemTypeList] = useState([]);
  const [selItemType, setItemType] = useState('');
  const [category, setCategory] = useState(null);
  const [subCat, setSubCat] = useState([]);
  const [subCatData, setSubCatData] = useState([]);
  const [catData, setCatData] = useState([]);
  const [units, setUnits] = useState([]);
  const [sections, setSections] = useState([]);
  const [image, setImage] = useState({});
  const [selectFields, setSelectFields] = useState({unit:null,section:null});
  const [ uploadedFile, setUploadedFile ] = useState([])
  const [ uploadFileStatusBlock, setUploadFileStatusBlock ] = useState('');
  const [modalFormStatusObj, setModalFormStatusObj] = useState({ text: '' });
  const [fileUpload, setFileUpload] = useState(null)
  const [showUpload, setShowUpload] = useState(false);
  const [isDownloading, setIsDownloading] = useState(false);
  const [editFormFields, setEditFormFields] = useState(EditFormFields);
  const[itemTypeValue,setItemTypeValue]=useState(null);
  const [itemClassifiers,setItemClassifiers]=useState([]);
  const [blobFile, setBlobFile] = useState(null)
  const[widthHeight,setWidthHeight]=useState();
  const[base64,setBase64]=useState("");
  const sType = localStorage.getItem('sType');
  const DOMAIN = (sType === 'dfp' ? DFPAPIEndpoint : APIEndpoint);
  let invData={};
  const stateRef =useRef({});
  stateRef.current=state;

  const preCompile = useMemo(() => ({
    uploadTitle: t('pages.inventoryContent.itemMaster.uploadItems')
  }), [ready, t,state]);

    useEffect(() => {
      if(state.message){
        showToast();
      }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [state]);

  const { hasPermission: createitemMaster } = usePermissions('create', "orn:Account:ModifyItemMaster");
  const { hasPermission: edititemMaster } = usePermissions('edit', "orn:Account:ModifyItemMaster");
  const { hasPermission: viewitemMaster } = usePermissions('viewDetails',"orn:Account:ModifyItemMaster");
  const { hasPermission: downloaditemMaster } = usePermissions('download',"orn:Account:ModifyItemMaster");
  const { hasPermission: uploaditemMaster } = usePermissions('upload',"orn:Account:ModifyItemMaster");

  const fetchSubCategoryList = useCallback(
    async (categoryObj) => {
      setSubCatData([]);
      setSubCat([]);
      try {
      
        const resp = await DOMAIN.get('subcategories/' + categoryObj.key);
        if (resp.result.length > 0 && resp.success) {
          const options=[{key:0,label:'Select Sub Category',value1:"",value:""}];
          resp.result.forEach( (fieldValue, index) => {
              options.push({key: fieldValue.id, label: fieldValue.value,value1: fieldValue.value});
          });
          /**
           * Set to edit form sub category list
           */
  
          setSubCat( editFormFields.map( editRow => {
            if (editRow.attribute === 'subCategory' ) {
              editRow.initialValue=stateRef.current.selectedRows?.subCategory??"";
              editRow.value=stateRef.current.selectedRows?.subCategory??"";
              editRow.options=options;
              editRow.disabled=false;
            }
            return editRow;
          }))
  
          setSubCatData(options)
        }
        else {
  
        }
      } catch (error) {
        
      }
    },
    [state, editFormFields],
  )
  ;
  const showToast = () => {
    toast.dismiss();
      if (state.message) {
      toast.error(state.message?.text, {
        position: toast.POSITION.TOP_CENTER,
        hideProgressBar: true,
        pauseOnHover: true,
        draggable: false,
        autoClose: 3800,
        style: {
          backgroundColor: '#d9534f',
          color: '#fff',
          borderRadius: '8px',
          fontSize: '1rem',
          width:'30rem'
        }
      });
    }
  };
  const fetchItemTypes = useCallback(
    async () => {
      try {
          const resp = await DOMAIN.get('itemTypes');
      if (resp.result.length > 0 && !itemTypeList.length) {
        const options = [{key: 0, label:'Select Item Type', value: ''}];
        resp.result.filter( (fieldValue, index) => {
          options.push({key: index+1, label: fieldValue, value: fieldValue});
          return fieldValue;
        });

        setItemTypeList( options );

        /**
         * Set to edit form itemType list
         */

      }
      else {
      }
      } catch (error) {

      }

    },
    [],
  )

  const fetchItemClassifiers = useCallback(
    async () => {
      if(itemClassifiers.length)return;
      try {
          const resp = await DOMAIN.get('itemClassifiers');
      if (resp.result.length > 0 && !itemClassifiers.length) {
        const options = [{key: 0, label:'Select Item Classifier', value: ''}];
        resp.result.filter( (fieldValue, index) => {
          options.push({key: index+1, label: fieldValue.displayName, value: fieldValue.name});
          return fieldValue;
        });

        setItemClassifiers( options );

        /**
         * Set to edit form itemType list
         */

      }
      else {
      }
      } catch (error) {

      }

    },
    [],
  )
  
  const fetchUnits = useCallback(
    async () => {
      try {
         const resp = await DOMAIN.get('units');
      if (resp.result.length > 0 && units.length === 0) {
        const options = [{key: 0, label: 'Select Unit', value: ''}];
        resp.result.filter( (fieldValue, index) => {
          options.push({key: index+1, label: fieldValue, value: fieldValue});
          return fieldValue;
        });
        setUnits( options );

        /**
         * Set to edit form itemType list
         */

      }
      else {
      }
      } catch (error) {

      }

    },
    [units],
  )
  ;

  const fetchSection = useCallback(
    async () => {
      try {
        const resp = await DOMAIN.get('sections');
      if (resp.result.length>0 && !sections.length) {
        const options = [{key: 0, label: 'Select Section', value: ''}];
        resp.result.filter( (fieldValue, index) => {
          if (fieldValue!==""){
            if(fieldValue===null){
              options.push({key: index+1, label: "null", value: ""});
            }else{
              options.push({key: index+1, label: fieldValue, value: fieldValue});
            }
          }
          return fieldValue;
        });
        setSections( options );
        /**
         * Set to edit form section list
         */

      }
      else {
      }
      } catch (error) {

      }

    },
    [sections],
  )
  ;
  const fetchCategoryList = useCallback(
    async () => {
      try {
        const resp = await DOMAIN.get('categories');
      if (resp.result.length > 0 && !catData.length) {
        const options = [{key: 0, label: 'Select Category', value: ''}];
        resp.result.filter( (fieldValue) => {
          options.push({key: fieldValue.id, label: fieldValue.value, value: fieldValue.value});
          setCatData(options)
          return fieldValue;
        });

        /**
         * Set to edit form category list
         */

      } else {
      }
      } catch (error) {

      }


    },
    [catData],
  )
  const refreshTable = useCallback(
    () => {
      tableRef.current.refreshTableHandler(selItemType);
    },
    [selItemType],
  )
  const setImageObj=useCallback(
    ()=>{
      let locS=''
      if(blobFile?.length){
        const timestamp = new Date().getTime();
        locS= blobFile.replace("http://localhost:3000", HOST_SERVER)+`?t=${timestamp}`;
        setImage({
        imgName: fileUpload?.name,
        imgType: fileUpload?.type,
        imgSize: fileUpload?.size,
        _data: base64,
        width: widthHeight?.width,
        height: widthHeight?.height,
        localSrc: locS
    })
      }
    },
    [base64, blobFile, fileUpload, widthHeight],
  )
  const setEditFormCheckFields = useCallback(() => {
    const isEdit = stateRef.current?.selected?.action === 'editItem';
    const isAdd = stateRef.current?.selected?.action === 'addNewItem';

    const getFieldsForType = () => {
      switch (itemTypeValue) {
        case "Product":
           return [...EditFormFields, ...editFields];
        case "Combo":
         {
           // Insert 'Tracking Strategy' after a specific field, e.g., after 'itemClassifier'
           const insertAfterAttr = 'itemClassifier'; // Change as appropriate
           const insertIndex = EditFormFields.findIndex(f => f.attribute === insertAfterAttr);
           const before = EditFormFields.slice(0, insertIndex + 1);
           const after = EditFormFields.slice(insertIndex + 1);
           return [
             ...before,
             { label: 'Tracking Strategy', attribute: 'trackingStrategy', type: 'select', disabled: false, options: [...TrackingStat], required: true },
             ...after,
             ...editFields
           ];
         }
        case "Serving":
        case "MRO":
          return isEdit ? [...EditFormFields, ...editFields2] : [...defaultEditFields];
        case "Service":
          return isEdit ? [...EditFormFields, ...editFields4] : [...defaultEditFields, ...editFields4];

        case "SeatUpgrade":
          return isEdit ? [...EditFormFields, ...editFields3] : [...defaultEditFields];
        default:
          return [...defaultEditFields];
      }
    };

    const addCommonOptions = (item) => {
      if (item.attribute === 'itemType') {
        return { ...item, options: itemTypeList };
      }
      if (item.attribute === 'itemClassifier') {
        return { ...item, options: itemClassifiers };
      }
      if (item.attribute === 'section') {
        return { ...item, options: sections };
      }
      if (item.attribute === 'unit') {
        return { ...item, options: units };
      }
      return item;
    };

    const  applyEditSettings = (item) => {
      let updated = addCommonOptions(item);

      if (["itemType", "itemCode", "itemName"].includes(item.attribute)) {
        updated = { ...updated, disabled: true };
      }

      if (item.attribute === 'category') {
        const value = stateRef.current.selectedRows?.category;
        const options = catData;
        const selCategoryObj = options.find(row => row.value === value);

        if (selCategoryObj) {
          setCategory(selCategoryObj);
        }
        updated = {
          ...updated,
          options,
          value
        };

      }
      return updated;
    };

    const applyAddSettings = (item) => {
      let updated = addCommonOptions(item);

      if (["itemType", "itemCode", "itemName","itemClassifier"].includes(item.attribute)) {
        updated = { ...updated, disabled: false };
      }

      if (item.attribute === 'category') {
        updated = {
          ...updated,
          value: "",
          options: catData,
          initialValue: ""
        };
      }

      if (item.attribute === 'subCategory') {
        updated = {
          ...updated,
          options: [{ key: 0, label:'Select Sub Category', value1: '', value: '' }],
          disabled: true,
          initialValue: ""
        };
      }

      return updated;
    };

    if ((isEdit && stateRef.current.selectedRows) || isAdd) {
      const updatedFields = getFieldsForType().map(item =>
        isEdit ? applyEditSettings(item) : applyAddSettings(item)
      );
      setEditFormFields(updatedFields);

      if (isEdit) {
        const updatedSubCat = updatedFields.map(item => {
          if (item.attribute === "subCategory") {
            return {
              ...item,
              initialValue: stateRef.current.selectedRows.subCategory,
              value: stateRef.current.selectedRows.subCategory,
              disabled: false
            };
          }
          return item;
        });
        setSubCat(updatedSubCat);
      }
    }
  }, [itemTypeValue, itemTypeList,itemClassifiers, sections, units, catData]);



  React.useEffect( () => {
    refreshTable();
  }, [refreshTable, selItemType, tableRef]);

  React.useEffect( () => {
    if(!itemTypeList.length){
    fetchItemTypes();
    }
    if(!itemClassifiers.length){
      fetchItemClassifiers()
    }
  }, [ready]);

  React.useEffect( () => {
    setImageObj();
  }, [base64, blobFile, setImageObj, widthHeight]);

  React.useEffect( () => {
    if(state?.selected?.action!==""){
      stateRef.current=state;
      fetchCategoryList();
      fetchSection();
      fetchUnits();
      setEditFormCheckFields();
    }
  }, [state,itemTypeValue]);


  useEffect( () => {
    if (category) {
      fetchSubCategoryList(category);
    }
  }, [category, fetchSubCategoryList]);


  const onAction = async (e, action, selectedRowData) => {
    const {itemId,itemType,subCategory}=selectedRowData;
    setItemTypeValue(itemType);

    const resp = await DOMAIN.get(`inventory/items/${itemId}`);
    if (resp.success) {
       invData=resp.result;
      invData.category=resp.result.category.id??resp.result.category.value;
      invData.subCategory=resp.result.subCategory.id??resp.result.subCategory.value;
      if(invData){
        setState( (_prev) => {
          return { ..._prev,selectedRows:selectedRowData, selected: {...invData,  action: 'editItem' }}
        });
      }
    }


    else {
    }

  };
  const onFieldChangeHandler = (e) => {
    const {name,value}=e.target;
  if(name==="itemType"){
    setItemTypeValue(value);
  }
    setModalFormStatusObj({ text: "" });
    if(name==='unit'){
      setSelectFields({...selectFields,unit:value})
    }
    if(name==='section'){
      setSelectFields({...selectFields,section:value})
    }
    if (name === 'category') {
      const selCategory = value;
      /**
       * Set to edit form
       */
       editFormFields.map( editRow => {
        if (editRow.attribute === name) {
          editRow.value = selCategory;
          const selCategoryObj = editRow.options.find(row => row.value === selCategory);
          if (selCategoryObj) {
            //
            setCategory(selCategoryObj);
          }
        }
        return editRow;
      });
    }
    if (name === 'subCategory') {
      const selSubCategory = value;
      /**
       * Set to edit form
       */

       setSubCat(editFormFields.map( editRow => {
        if (editRow.attribute === "subCategory") {
          editRow.value = selSubCategory;
        }
        return editRow;
      }))
    }
  };
  const onClose = () => {
    setState((_prev) => {
      return { ..._prev, selected: false,imageRemoved:false }
    });
    editFormFields.forEach((items)=>{
    if(items.value||items.initialValue){
        delete items["value"];
        delete items["initialValue"];
      }
    })
    setModalFormStatusObj({text:''});
    setItemTypeValue(null);
    setSubCat([]);
    invData={};
    setImage({});
    setSubCatData([]);
    setCategory(null);
    resetImageSelection(false);
  }

  const filterData = {
    action: 4,
    collection: '',
    filterOperation: 'or',
    filters: [],
    limit: 50,
    page: 1,
    searchParam: ''
  };

  const fetchItemMaster = async (page=1, perPage=50) => {
    if(!viewitemMaster){
      return{items:[],count:0}
    }
    filterData.page = page;
    filterData.limit = perPage;
    filterData.searchParam = searchKey;
    if (selItemType) {
      const isItemTypeExists = filterData.filters.find(row => row.itemType ? true : false);
      if (!isItemTypeExists) {
        filterData.filters.push({ itemType: selItemType });
      } else {
        filterData.filters.map( row => {
          row.itemType = selItemType;
          return row;
        });
      }
    }
    const res = await DOMAIN.post('master/process', JSON.stringify(filterData));
    return res;
  }

const onDownloadItemMaster=async()=>{
  if(isDownloading) return;
  let header={
    'Accept':'text/csv'
  }
    try {
      setIsDownloading(true)
    const res= await DOMAIN.post(`downloads/itemMaster`,{},header);
    if(res.status==='scheduled'){
      setTimeout(() => {
        const dowId = DOMAIN.get(`downloads/status/${res.id}`);
        dowId.then((val) => {
          if (val.status === "completed") {
              DOMAIN.get(`downloads/analytics/${val.fileName}${val.fileExtension}`)
                  .then((ItemMasterDwnld) => {
                      const url = window.URL.createObjectURL(new Blob([ItemMasterDwnld]));
                      const link = document.createElement('a');
                      link.href = url;
                      link.setAttribute('download', val.fileName + '.csv');
                      document.body.appendChild(link);
                      link.click();
                      setIsDownloading(false);
                  })
                  .catch((error) => {

                      setIsDownloading(false);
                  });
          }
      });
        }, 4000);
    }
    }
     catch (error) {
      setState((_) => {
        return { ..._,message:{text:error?.data?.message},};
      })
      setTimeout(() => {
        setState((prevState) => ({
          ...prevState,
          message: null,
        }));
      }, 5000);
       setIsDownloading(false)
     }
  }
 const getCatSubCatObj=(obj=null,stateVal=null)=>{
  let catObj = {},
  subCatObj = {};

  if (obj === null && stateVal) {
    catObj = catData.find(c => (typeof stateVal.category==='number'?c.key ===stateVal.category:c.value === stateVal.category) );
    subCatObj = subCatData.find(c => (typeof stateVal.subCategory==='number'?c.key ===stateVal.subCategory:c.value === stateVal.subCategory));
  }

  else if (obj && obj.category) {
    catObj = catData.find(c => c.value === obj.category);
  }

  else if (obj && !obj.category && stateVal) {
    catObj = catData.find(c => (typeof stateVal.category==='number'?c.key ===stateVal.category:c.value === stateVal.category));
  }

  if (obj && obj.subCategory) {
    subCatObj = subCatData.find(c => c.value === obj.subCategory);
  }

  else if (obj && !obj.subCategory && stateVal) {
    subCatObj = subCatData.find(c => (typeof stateVal.subCategory==='number'?c.key ===stateVal.subCategory:c.value === stateVal.subCategory));
  }

  return [catObj, subCatObj];
 }

 const imageDimension=(imgData)=>{
  let i = new Image();
  i.onload = function(){
  setWidthHeight({width:i.width,height:i.height})
  };
  i.src = imgData;

}
const encodeImageFileAsURL = (element) => {

  if (element && (element instanceof File || element instanceof Blob)) {
    setBlobFile(URL.createObjectURL(element));
    setFileUpload(element);

    const reader = new FileReader();
    reader.onloadend = () => {
      imageDimension(reader.result);
      setBase64(reader.result);
    };
    reader.readAsDataURL(element);
  } else {

  }
};



const resetImageSelection=(closeReset=false)=>{
  if(closeReset){
    setState((_)=>({..._,selected:{..._.selected,image:null},imageRemoved:true}));
  }
  setImage({});
  setBlobFile(null);
  setFileUpload(null);
  setModalFormStatusObj({text:""})
 }

const getItemChecked=(updated,option,stateSel=false)=>{
if(updated && (updated[option]===true || updated[option]===false)){
 return updated[option];
 }
 else{
 return stateSel
}
}
const handleReset = () => {

  let timerId = setTimeout(() => {
    clearTimeout(timerId);
    setState((_) => {
      return { ..._, resetDataSource: !_.resetDataSource };
    })
    onClose();
  }, 1200)
}
const getImageStat = (mod, data) => {

  const imageSrc = Boolean(Object.keys(image).length) ? image : (mod?.image ?? data?.image);

  if (Boolean(Object.keys(image).length)) {
    return image;
  }
  return imageSrc ? { localSrc: imageSrc } : null;
};


const createItemMaster = (updated, selected, actionType) => {
  const [cat, subCat] = getCatSubCatObj(updated, selected);
if(cat===undefined || subCat===undefined){
   setModalFormStatusObj({ error: "Category or Sub category Id is unknown." });
   return;
} 

const baseItemMaster = {
  itemId: updated?.itemId ?? selected?.itemId,
  itemName: updated?.itemName ?? selected?.itemName,
  itemCode: updated?.itemCode ?? selected?.itemCode,
  itemType: updated?.itemType ?? selected?.itemType,
  itemClassifier:updated?.itemClassifier ?? selected?.itemClassifier,
  trackingStrategy:updated?.trackingStrategy ?? selected?.trackingStrategy,
  ssrCode: updated?.ssrCode ?? selected?.ssrCode,
  hsn: updated?.hsn ?? selected?.hsn,
  barcode: updated?.barcode ?? selected?.barcode,
  category: {id:cat.key,value:cat.value},
  subCategory: {id:subCat.key,value:subCat.value},
  description: updated?.description ?? selected?.description,
  unit: selectFields.unit ?? selected?.unit,
  baseUnit: updated?.baseUnit ?? selected?.baseUnit,
  section: selectFields.section ?? selected?.section,
  colorCode: updated?.colorCode ?? selected?.colorCode,
  replenishable: updated?.replenishable ?? selected?.replenishable,
  image:getImageStat(updated,selected),
  domestic: getItemChecked(updated, 'domestic', selected?.domestic),
  international: getItemChecked(updated, 'international', selected?.international),
  bob: getItemChecked(updated, 'bob', selected?.bob),
  corporate: getItemChecked(updated, 'corporate', selected?.corporate),
  webMeal: getItemChecked(updated, 'webMeal', selected?.webMeal),
  perishable: getItemChecked(updated, 'perishable', selected?.perishable),
  saleable: getItemChecked(updated, 'saleable', selected?.saleable),
  beverage: getItemChecked(updated, 'beverage', selected?.beverage),
  merchandise: getItemChecked(updated, 'merchandise', selected?.merchandise),
  stationary: getItemChecked(updated, 'stationary', selected?.stationary),
  groupMeal: getItemChecked(updated, 'groupMeal', selected?.groupMeal),
  crewMeal: getItemChecked(updated, 'crewMeal', selected?.crewMeal),
  liquor: getItemChecked(updated, 'liquor', selected?.liquor),
  dutyFree: getItemChecked(updated, 'dutyFree', selected?.dutyFree),
  additionalSmuLoadable: getItemChecked(updated, 'additionalSmuLoadable', selected?.additionalSmuLoadable),
  ...(!state.imageRemoved?{}:{shouldDeleteImage:state.imageRemoved}),
  smuLoadable:getItemChecked(updated, 'smuLoadable', selected?.smuLoadable),
  weight: updated?.weight !== undefined && updated?.weight !== '' && !isNaN(parseFloat(updated?.weight))
      ? Number(updated?.weight)
      : selected?.weight,
};


  if (actionType === 'addNewItem') {
    baseItemMaster.itemName = updated?.itemName ?? '';
    baseItemMaster.itemCode = updated?.itemCode ?? '';
    baseItemMaster.description = updated?.description ?? '';
    baseItemMaster.unit = selectFields.unit ?? '';
    baseItemMaster.image = Boolean(Object.keys(image).length) ? image : null;
  }

  return baseItemMaster;
};

const onEditSubmit = async (e, updated) => {
  const { selected } = state;
if((!selected?.itemClassifier && !updated?.itemClassifier)||(selected?.itemClassifier && updated?.itemClassifier==='')){
     setModalFormStatusObj({ error: "Please fill all mandatory fields*" });
}
else if(((updated?.itemType ?? selected?.itemType) ==='Combo') && ((!selected?.trackingStrategy && !updated?.trackingStrategy)||(selected?.trackingStrategy && updated?.trackingStrategy===''))){
     setModalFormStatusObj({ error: "Please fill all mandatory fields*" });
}
else{
  const actionType = selected?.action;
  if (Boolean(updated) && actionType === 'editItem') {
    const bodyItemMaster = createItemMaster(updated, selected, 'editItem');
    if(!bodyItemMaster) return;
    try {
      const res = await DOMAIN.put(`inventory/items/${selected.itemId}`, bodyItemMaster);
      if (res.success) {
        setModalFormStatusObj({ text: res.msg });
        handleReset();
      }
    } catch (error) {

      const errObj = JSON.parse(error.message);
      setModalFormStatusObj({ error: errObj.data.msg });
    }
  }

  else if (updated === null && actionType === 'editItem') {
    const bodyItemMaster = createItemMaster(updated, selected, 'editItem');
    if(!bodyItemMaster) return;
    delete bodyItemMaster['action'];

    try {
      const res = await DOMAIN.put(`inventory/items/${bodyItemMaster.itemId}`, bodyItemMaster);
      if (res.success) {
        setModalFormStatusObj({ text: res.msg });
        handleReset();
      }
    } catch (error) {
      const errObj = JSON.parse(error?.message??error);
      if(!errObj.status){
        setModalFormStatusObj({ error:'Something went wrong. Please try again after some time.'});
      }else{
        setModalFormStatusObj({ error: errObj.data.message||errObj.data?.msg ||'Something went wrong. Please try again after some time.' });
      }

    }
  }

  else if (Boolean(updated) && actionType === 'addNewItem') {
    const bodyItemMaster = createItemMaster(updated, selected, 'addNewItem');
    if(!bodyItemMaster) return;
    try {
      const res = await DOMAIN.post(`inventory/items`, bodyItemMaster);
      if (res.success) {
        setModalFormStatusObj({ text: res.msg });
        handleReset();
      } else {
        setModalFormStatusObj({ text: res.message });
        handleReset();
      }
    } catch (error) {
      const errObj = JSON.parse(error.message);
      setModalFormStatusObj({ error: errObj.data.message||errObj.data?.msg });
    }
  }

  else if (actionType === 'addNewItem') {
    setModalFormStatusObj({ error: "Please fill all mandatory fields*" });
  }
}
};


  const onAddItemHandler = () => {

    setState( (_prev) => {
      return { ..._prev, selected: { action: 'addNewItem' } };
    });

    /**
     * Set to edit form
     */

  }
  // const onPerLimitChange = (e) => {
  //   setPerPageLimit(Number(e.target.value));
  // };

  const onSearch = (e) => {
      setSearchKey(e.target.value);
  };

  const onItemTypeChange = (e) => {
      setItemType(e.target.value);
  }
  const onUploadTaxMaster=()=>{
    setShowUpload(true)

  }
  const onUploadClose = () => {
    setUploadedFile([]);
    setShowUpload(false);
    setUploadFileStatusBlock('');
  }
  const onDownloadSampleFile = () => {
    onDownloadXlsFile('samples/downloads/Item_Master_Upload_Sample','Item_Master_Upload_Sample')
  }
  const onUploadFileChangeHandler = async (e) => {
    const file=e.target.files[0];
    setUploadedFile(e.target.files[0]);
    setUploadFileStatusBlock('<p>Please wait while we process your data...</p>');

    const formData = new FormData();
    formData.append('scheduleLater', false);
    formData.append('listName', undefined);
    formData.append('targetSectorType', undefined);
    formData.append('stores', []);
    formData.append('warehouses', []);
    formData.append('file', file);

    try {
      await DOMAIN.post('inventory/upload', formData);
      setUploadedFile([]);
      setUploadFileStatusBlock('<p>File Imported Successfully.</p>');
      setState( (_prev) => {
        return { ..._prev,resetDataSource:!_prev.resetDataSource}
      });

    }
    catch(error) {
      e.target.value = null;
      setUploadedFile([]);
      let { status, data } = JSON.parse( error.message );
      let msgHeading = data?.Error || data?.message || error.message;
      msgHeading= msgHeading.includes('status')?`Failed to upload.`:msgHeading;
      let msgContent = "";
      if (status === 400) {
            data.errors.forEach( _ => {
            const lineNum = _.lineNumber;
            const errorMsgArr = [];
            _.errors.forEach(erObj => {
              errorMsgArr.push( erObj.field + ' | ' + erObj.message + ' \n<br>' );
            });

            msgContent += '<br>Line ' + lineNum + ': \n<br>' + errorMsgArr.join(' ');
        });
      } else if(status===0 && !data){

        msgContent += `Error occurred while uploading items sheet!<br>Please try again.`;
    }
      else {
        msgContent += `Error occurred while uploading items sheet!<br>Please fix the errors and re-upload.`;
      }


      setUploadFileStatusBlock("<p class='listErrorMessagesCls'>"+ msgHeading + "</p>" +
                                "<p class='listErrorMessagesCls sm-scrollbar border p-2 pt-1'>" + msgContent +"</p>"
                              );
    }
};

  return (
      <div className="op-aircraft-container flexCol full-flex ag-theme-alpine-dark">
      {
        <>
  <div className="flexRow gap10 width100 margTop8 margBot10 justifyContentSpaceBetween">
  <div className="flexRow justifyContentFlexStart alignItemsBaseline">
    <button  className="saleType-div m-2 margLeft7">
      <select
        className="select-item darkBlue-bg"
        onChange={onItemTypeChange}
        value={selItemType !== null ? selItemType : ''}
        id="saleTypeId"
      >
        {itemTypeList.map((item, index) => (
          <option key={index} value={item.value}>
            {item.label}
          </option>
        ))}
      </select>
    </button>
  </div>

  <div className="flexRow justifyContentCenter alignItemsCenter width100 content-tabs">
    <div className="margLeft margBot10 margTop8 underline">
      <span><img className="icon-size" alt={t('filters.searchText')} src={searchIcon} /></span>
      <span>
        <input
          className="search"
          onChange={onSearch}
          type="search"
          placeholder={t('filters.searchText')}
          value={searchKey}
        />
      </span>
    </div>
  </div>
  <div className='flexRow margTop8 justifyContentFlexEnd'>
          <div className="margLeft flexRow justifyContentFlexEnd alignItemsBaseline">
          {uploaditemMaster?<button title={t('filters.uploadItems')} className='upload dropdownStyle1-TextMedium' onClick={() => onUploadTaxMaster(true)}> <span><img  className="icon-size-min" alt='uploadItem' src={uploadItemIcon} /></span></button>:<></>}&nbsp;
              {downloaditemMaster? <div className="flexRow justifyContentFlexStart margRight">

                      {isDownloading ? (
                               <button className="margRight" title={t('filters.downloadingMaster')}>
                                    <img
                                      src={LoadingGIF}
                                      className="margBottom0 icon-size-min"
                                      alt="Loading"
                                    />
                                  </button>
                              ) : (

                                  <button
                                    disabled={isDownloading}
                                    className="margRight"
                                    style={{ cursor: 'pointer' }}
                                    title={t('filters.downloadMaster')}
                                   onClick={onDownloadItemMaster}
                                  >
                                    <img src={DOWNLOAD_ICON} className="node-icon svg" alt="" />
                                  </button>
                                )
                              }

          </div>:<></>}

          </div>
        </div>

  {createitemMaster && (
    <div className="flexRow justifyContentFlexEnd">
      <button className="add-item-button m-2" onClick={onAddItemHandler}>
        {t('buttons.addItem')}
      </button>
    </div>
  )}

</div>


          <DataGrid
            ref={tableRef}
            className="full-flex"
            columns={[...Columns]}
            initialPageLimit={perPageLimit}
            showDefaultFilters={false}
            searchKey={searchKey}
            selItemType={selItemType}
            getRows={fetchItemMaster}
            rowSelection="multiple"
            actions={[{ title: '', detail: [{src: editIcon2,value:"EditItem",title:'Edit'}] }]}
            onAction={onAction}
            onAddItemHandler={onAddItemHandler}
            columnResize={true}
            resetDataSource={state.resetDataSource}
          />
        </>
      }
      {
        state && Boolean(state.selected) ?  (
          <EditModal
            key={state.selected.action}
            title={(state.selected.action === 'editItem' && edititemMaster) ? 'Edit Item' : 'Add Item'}
            onClose={onClose}
            catData={catData}
            subCatData={subCatData}
            blobFile={blobFile}
            buttonLabel={'Save'}
            fileUpload={fileUpload}
            imageUrl={state?.selected?.image}
            resetImageSelection={resetImageSelection}
            encodeImageFileAsURL={encodeImageFileAsURL}
            modalFormStatusObj={modalFormStatusObj}
            setItemTypeValue={setItemTypeValue}
            onSubmit={onEditSubmit}
            onChange = {onFieldChangeHandler}
            fields={ subCat?.length>0?subCat.map( (elt) => {
              if (state.selected.action === 'editItem') {
                return {...elt, initialValue: state.selected[elt.attribute]?? ''}
              }
              else {
                return {...elt, initialValue: '' }
              }
            }):editFormFields.map( (elt) => {
                if (state.selected?.action === 'editItem') {
                  return {...elt, initialValue: state.selected[elt.attribute]?? ''}
                }
               
                else {
                  return {...elt, initialValue: '' }
                }
              })
            }
          />
        )
        : null
      }
      <ToastContainer/>
       {
        showUpload && uploaditemMaster &&
        <UploadModal
        modelTitle={preCompile.uploadTitle}
        onUploadClose={onUploadClose}
        onDownloadSampleFile={onDownloadSampleFile}
        uploadedFile = { uploadedFile }
        onUploadFileChangeHandler = { (e) => onUploadFileChangeHandler(e) }
        uploadFileStatusBlock = { uploadFileStatusBlock }
        allowedExtensions={ MIMETypes.excel }
        />
      }
      {
      !ready &&<div className='overlay_hide sub'></div>
      }
    </div>
  )
}
